import React from 'react';
import { Plus } from 'lucide-react';
import { cn } from '../../lib/utils';

const WorkflowStepDropZone = ({
  index,
  label,
  isValid,
  isHovered,
  onClick,
  onDragEnter,
  onDragOver,
  onDragLeave,
  onDrop,
}) => {
  return (
    <div
      className="flex justify-center py-1"
      data-testid={`workflow-drop-zone-${index}`}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <button
        type="button"
        onClick={isValid ? onClick : undefined}
        disabled={!isValid}
        aria-label={isValid ? 'Move action here' : 'Move not allowed here'}
        className={cn(
          'flex min-w-[180px] items-center justify-center gap-1.5 rounded-lg border border-dashed px-4 py-2 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/40',
          isValid && 'border-emerald-400 bg-emerald-50 text-emerald-700 hover:border-emerald-500 hover:bg-emerald-100',
          !isValid && 'cursor-not-allowed border-slate-200 bg-slate-50 text-slate-400',
          isHovered && isValid && 'border-emerald-500 bg-emerald-100 ring-2 ring-emerald-300/50',
        )}
      >
        <Plus size={12} className={cn(!isValid && 'opacity-60')} />
        <span>{label}</span>
      </button>
    </div>
  );
};

export default WorkflowStepDropZone;
